import { Injectable } from '@angular/core';
import { TransponderModel, BaseResponseDTO, DefaultService } from "@psnb/psnb-api";
import {Observable} from "rxjs";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyTransponderModelService {

  constructor(private powerSupplyService: DefaultService) {
  }

  getAllModelsFromService() {
    return this.powerSupplyService.getTransponderModels().pipe(map(result => result));
  }

  createTransponderModel(jsonTransponderModel: TransponderModel) {
    return this.powerSupplyService.createTransponderModel(jsonTransponderModel).pipe(map(result => result));
  }

  updateTransponderModel(jsonTransponderModel: TransponderModel) {
    return this.powerSupplyService.updateTransponderModel(jsonTransponderModel).pipe(map(result => result));
  }

  deleteTransponderModel(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deleteTransponderModel(id).pipe(map(result => result));
  }

  getTransponderModelsByRootId(rootId: number) {
    return this.powerSupplyService.getTransponderModelsByRootId(rootId).pipe(map(result => result));
  }
}
